import { useLeadsStore } from '../stores/leads.store'

export function useLeads() {
  const leads = useLeadsStore((state) => state.leads)
  const meta = useLeadsStore((state) => state.meta)
  const isLoading = useLeadsStore((state) => state.isLoading)
  const isSubmitting = useLeadsStore((state) => state.isSubmitting)
  const error = useLeadsStore((state) => state.error)
  const filters = useLeadsStore((state) => state.filters)

  const fetchLeads = useLeadsStore((state) => state.fetchLeads)
  const setFilters = useLeadsStore((state) => state.setFilters)
  const createLead = useLeadsStore((state) => state.createLead)
  const updateLead = useLeadsStore((state) => state.updateLead)
  const deleteLead = useLeadsStore((state) => state.deleteLead)
  const bulkUploadLeads = useLeadsStore((state) => state.bulkUploadLeads)
  const clearError = useLeadsStore((state) => state.clearError)

  return {
    leads,
    meta,
    isLoading,
    isSubmitting,
    error,
    filters,
    fetchLeads,
    setFilters,
    createLead,
    updateLead,
    deleteLead,
    bulkUploadLeads,
    clearError,
  }
}
